import React, { useRef } from "react";
import {
  Text,
  View,
  Image,
  FlatList,
  TouchableOpacity,
  StyleSheet,
  Animated,
  Dimensions,
} from "react-native";
import * as Linking from "expo-linking";
import { Ionicons } from "@expo/vector-icons";
import { useSelector } from "react-redux";
import GlobalStyles from "../components/GlobalStyles";
import FooterBarWide from "../components/footerBarWide";
import MenuBar from "../components/headers/MenuBar";
import StatusBar from "../components/headers/StatusBar";

const FadeInView = (props) => {
  const fadeAnim = useRef(new Animated.Value(0)).current;
  React.useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 1000,
      useNativeDriver: false,
    }).start();
  }, [fadeAnim]);

  return (
    <Animated.View
      style={{
        ...props.style,
        opacity: fadeAnim,
      }}
    >
      {props.children}
    </Animated.View>
  );
};

function CardListComponent({ item }) {
  return (
    <View style={{ alignItems: "center" }}>
      <FadeInView style={{ width: 350 }}>
        <View style={styles.cardBox}>
          {item.active ? (
            <Image style={styles.cardImage} source={{ uri: item.imageUrl }} />
          ) : (
            <Image
              style={styles.cardImageTrans}
              source={{ uri: item.imageUrl }}
            />
          )}
          {item.links.map(function (link) {
            var itemText = "";
            switch (link.typeId) {
              case 1:
                itemText = "Cancel stolen or lost card";
                break;
              case 2:
                itemText = "Apply Online";
                break;
              case 3:
                itemText = "Activate debit card";
                break;
              default:
                itemText = "";
            }
            return (
              <TouchableOpacity
                style={[
                  link.typeId == 2
                    ? [styles.option, { borderBottomWidth: 0 }]
                    : styles.option,
                ]}
                activeOpacity={0.5}
                onPress={() => Linking.openURL(link.url)}
                key={item.cardNumberShortened + link.typeId}
              >
                <View style={styles.SubmitButtonStyle}>
                  <View style={styles.optionTextContainer}>
                    <Text
                      style={[
                        link.typeId == 2
                          ? [styles.optionTextBlue]
                          : styles.optionText,
                      ]}
                    >
                      {itemText}
                    </Text>
                  </View>
                  <View style={styles.optionIconContainer}>
                    <Ionicons
                      name={"md-arrow-forward"}
                      size={24}
                      color={[link.typeId == 2 ? ["#2F7696"] : "rgba(0,0,0,1)"]}
                    />
                  </View>
                </View>
              </TouchableOpacity>
            );
          })}
        </View>
      </FadeInView>
    </View>
  );
}

export default function AuraCardsScreen() {
  // const cardsLoaded = useSelector((state) => state.card.cardsLoaded); to be cleaned in next round
  const cards = useSelector((state) => state.card.cards);
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerLB}>
      {win.width > 768 ? (
        <View style={GlobalStyles.fullHeaderBarY}>
          <MenuBar data="2" />
          <View style={GlobalStyles.headerContainerKLYellow}>
            <View style={[GlobalStyles.headerTextYellow]}>
              <Text style={GlobalStyles.headingStyle}>Manage Aura Card</Text>
              <Text style={GlobalStyles.subheaderStyle}>
                Update your card settings
              </Text>
            </View>
          </View>
        </View>
      ) : (
        <View style={GlobalStyles.fullHeaderBarW}>
          <StatusBar data="C" />
          <View style={GlobalStyles.headerContainerKL}>
            <View style={[GlobalStyles.headerText]}>
              <Text style={GlobalStyles.headingStyle}>Manage Aura Card</Text>
              <Text style={GlobalStyles.subheaderStyle}>
                Update your card settings
              </Text>
            </View>
          </View>
        </View>
      )}

      <View style={GlobalStyles.bodyContainerCards}>
        <FlatList
          contentContainerStyle={styles.flatlistContainer}
          data={cards}
          renderItem={({ item }) => <CardListComponent item={item} />}
          keyExtractor={(item) => item.cardNumberShortened}
        />
      </View>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  cardImage: {
    width: "100%",
    height: 275,
    resizeMode: "contain",
  },
  cardImageTrans: {
    width: "100%",
    height: 275,
    resizeMode: "contain",
    opacity: 0.5,
  },

  cardBox: {
    paddingLeft: 30,
    paddingRight: 30,
  },

  option: {
    width: "100%",
    borderTopWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderColor: "#dddddd",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
    marginBottom: 5,
  },

  optionIconContainer: {
    marginLeft: 12,
  },

  optionText: {
    paddingTop: 3,
    alignSelf: "flex-start",
    color: "#000000",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  optionTextBlue: {
    paddingTop: 3,
    alignSelf: "flex-start",
    color: "#2F7696",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  SubmitButtonStyle: {
    flexDirection: "row",
  },

  optionTextContainer: {
    flex: 8,
  },

  optionIconContainer: {
    flex: 1,
  },
  flatlistContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignSelf: "center",
  },
});
